/* eslint-disable no-mixed-spaces-and-tabs */
import {
	motion,
	useScroll,
	useTransform,
	AnimateSharedLayout,
} from 'framer-motion'
import { getCookieConsentValue } from 'react-cookie-consent'

import { ProductDetail } from 'lib/hooks/use-products'
import Portal from 'components/Portal'
import BuyButton from './BuyButton'

type Props = {
	variant: ProductDetail[ 'variants' ][ 0 ]
}

// eslint-disable-next-line max-len
export default function Buy({ variant }: Props ) {
	const { scrollY } = useScroll()
	const y = useTransform(
		scrollY,
		[ 0, 850, 1000 ],
		[ 150, 150, getCookieConsentValue() ? 0 : 150 ]
	)

	return (
		<Portal selector="#__next">
			<AnimateSharedLayout>
				<motion.div
					className="product-mobile-nav"
					initial={{ y: 150 }}
					style={{ y }}
				>
					<BuyButton variant={variant} />
					<style jsx global>{`
						footer.container {
							padding-bottom: 120px;
						}
						.product-mobile-nav {
							position: fixed;
							bottom: 0;
							width: 100%;
							padding: 15px;
							display: flex;
							align-items: center;
							justify-content: space-between;
							background: #ffffff;
							border-top: 1px solid #D1D5D6;
							text-transform: lowercase;
							font-size: 18px;
						}
						.product-mobile-nav :global(.button) {
							height: 60px;
							width: 100%;
							padding-left: 36px;
							padding-right: 36px;
						}
					`}</style>
				</motion.div>
			</AnimateSharedLayout>
		</Portal>
	)
}
